import { render } from "./SaberTypesContent.vue?vue&type=template&id=48f150fe&ts=true"
import script from "./SaberTypesContent.vue?vue&type=script&lang=ts"
export * from "./SaberTypesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__